import React from 'react';
import Axios from 'axios';
import moment from 'moment';

import AutoSuggestPlayer from '../../shared/AutoSuggest/AutoSuggestPlayer';

const autoSuggTheme = {
	container: 'react-autosuggest-std__container',
	input: 'react-autosuggest-std__input',
	inputOpen: 'react-autosuggest-std__input--open',
	inputFocused: 'react-autosuggest-std__input--focused',
	suggestionsContainer: 'react-autosuggest-std__suggestions-container',
	suggestionsContainerOpen: 'react-autosuggest-std__suggestions-container--open',
	suggestionsList: 'react-autosuggest-std__suggestions-list',
	suggestion: 'react-autosuggest-std__suggestion',
	suggestionHighlighted: 'react-autosuggest-std__suggestion--highlighted',
	//suggestionFirst: 'react-autosuggest__suggestion--first',
	//sectionContainer: 'react-autosuggest__section-container',
	//sectionContainerFirst: 'react-autosuggest__section-container--first',
	//sectionTitle: 'react-autosuggest__section-title'
};

class EditUser extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			auth0_user_id: '',
			auth0_name: '',
			name: '',
			adminLevel: '',
			organisationsId: [],
			charters: [],
			leagues: [],
			seasons: [],
			playerId: '0',
			memberActive: '',
			memberDateActivation: '',
			memberDateExpiration: '',
			profilePicture: '',
 			streetaddress: '',
  		addresslevel2: '',
  		addresslevel1: '',
  		postalcode: '',
  		country: '',
  		email: '',
  		tel: '',
		};

		this.handleSubmit = this.handleSubmit.bind(this);
		this.handlePlayerChange = this.handlePlayerChange.bind(this);
		this.handleAdminLevelChange = this.handleAdminLevelChange.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleMemberActiveChange = this.handleMemberActiveChange.bind(this);
		this.handleCancel = this.handleCancel.bind(this);
	}

  loadUserFromApi() {
    var _this = this;

  	Axios.get('/api/users/' + _this.props.match.params.userid + '/extended').then(function (response) {

  		//console.log('USER');
  		//console.log(response.data);
  		var actDate;
  		var expDate;

  		if(response.data.memberDateActivation !== "") {
  			actDate = moment(response.data.memberDateActivation).utc().format("YYYY-MM-DD");
  		}
  		if(response.data.memberDateExpiration !== "") {
  			expDate = moment(response.data.memberDateExpiration).utc().format("YYYY-MM-DD");
  		}

    	_this.setState({
    		auth0_user_id: response.data.auth0_user_id,
    		auth0_name: response.data.auth0_name,
    		name: response.data.name,
    		adminLevel: response.data.adminLevel,
    		organisationsId: response.data.organisationsId,
    		charters: response.data.charters,
    		leagues: response.data.leagues,
    		seasons: response.data.seasons,
    		playerId: response.data.playerId,
    		memberActive: response.data.memberActive,
    		memberDateActivation: actDate,
    		memberDateExpiration: expDate,
    		profilePicture: response.data.profilePicture,
    		streetaddress: response.data.streetaddress,
    		addresslevel2: response.data.addresslevel2,
    		addresslevel1: response.data.addresslevel1,
    		postalcode: response.data.postalcode, 
    		country: response.data.country,
    		email: response.data.email,
    		tel: response.data.tel,
    	});
  	});
  }

 	componentDidMount() {
		this.loadUserFromApi();
 	}

	handleSubmit(e) {
		e.preventDefault();
		var _this = this;

		var playerId = this.state.playerId;
		if (playerId.toString() === '-1') {
			playerId = '0';
		}

		var userData = {
			name: this.state.name,
			adminLevel: this.state.adminLevel,
			organisationsId: this.state.organisationsId,
			charters: this.state.charters,
			leagues: this.state.leagues,
			seasons: this.state.seasons,
			playerId: playerId,
			memberActive: this.state.memberActive,
			memberDateActivation: this.state.memberDateActivation,
			memberDateExpiration: this.state.memberDateExpiration,
  		streetaddress: this.state.streetaddress,
  		addresslevel2: this.state.addresslevel2,
  		addresslevel1: this.state.addresslevel1,
  		postalcode: this.state.postalcode, 
  		country: this.state.country,
  		email: this.state.email,
  		tel: this.state.tel, 		
  	}

		var userId = this.props.match.params.userid;

		Axios.post('/api/users/edit', {
			userId: userId,
			userData: userData
		})
		.then(function(response) {
			const path = '/admsafe/users';
			_this.props.history.push(path);
		})
		.catch(function(error) {
			console.log(error);
		});
	}
	
	render() {
    var defaultDate = new Date();
    defaultDate = moment(defaultDate.toISOString()).utc().format("YYYY-MM-DD");

		return (
			<div className="row">
        <div className="col-md-12">
        <form className="form-horizontal" onSubmit={this.handleSubmit}>

				<h4>Édition d'un utilisateur</h4>

				<div className="form-group">
        <div className="row">
        <div className="col-md-12">
					<img className="img-profile-token" src={this.state.profilePicture} alt='photo'/> <br/><br/>
						id: {this.props.match.params.userid} <br/>
						auth0: {this.state.auth0_name} (user_id: {this.state.auth0_user_id}) <br/>
				</div>
				</div>
				</div>

				<div className="form-group">
        <div className="row">
        <div className="col-md-4">
					Nom Usager
					<input type="text" className="form-control" id="name" placeholder="Nom utilisateur"
						value={this.state.name || ''} onChange={this.handleChange}/>
				</div>
				</div>
				</div>

				<div className="form-group">
        <div className="row">
        <div className="col-md-4">
					Adresse
					<input type="text" className="form-control" id="streetaddress"
						value={this.state.streetaddress} onChange={this.handleChange}/>
				</div>
        <div className="col-md-4">
					Ville
					<input type="text" className="form-control" id="addresslevel2"
						value={this.state.addresslevel2} onChange={this.handleChange}/>
				</div>
        <div className="col-md-2">
					Province
					<input type="text" className="form-control" id="addresslevel1"
						value={this.state.addresslevel1} onChange={this.handleChange}/>
				</div>
        <div className="col-md-2">
					Code postal
					<input type="text" className="form-control" id="postalcode"
						value={this.state.postalcode} onChange={this.handleChange}/>
				</div>
				</div>
				</div>

				<div className="form-group">
        <div className="row">
        <div className="col-md-4">
					Pays
					<input type="text" className="form-control" id="country"
						value={this.state.country} onChange={this.handleChange}/>
				</div>
        <div className="col-md-4">
					Courriel
					<input type="text" className="form-control" id="email"
						value={this.state.email} onChange={this.handleChange}/>
				</div>
        <div className="col-md-4">
					Téléphone
					<input type="text" className="form-control" id="tel"
						value={this.state.tel} onChange={this.handleChange}/>
				</div>
				</div>
				</div>

				<div className="form-group">
        <div className="row">
        <div className="col-md-6">
					<input type="checkbox" id="memberActive" checked={this.state.memberActive} value="memberActive" 
						onChange={this.handleMemberActiveChange}/> Active member
				</div>
				</div>
				</div>

				<div className="form-group">
        <div className="row">
        <div className="col-md-4">
					Joueur
					<AutoSuggestPlayer theme={autoSuggTheme} playerId={this.state.playerId} dataChange={this.handlePlayerChange} />
				</div>
        <div className="col-md-4">
					Date d'activation (membre)
					<input className="form-control" type="date" id="memberDateActivation" 
            value={this.state.memberDateActivation || ''} 
						onChange={this.handleChange}></input>
				</div>
        <div className="col-md-4">
					Date d'expiration (membre)
					<input className="form-control" type="date" id="memberDateExpiration" 
						value={this.state.memberDateExpiration || ''} 
						onChange={this.handleChange}></input>
				</div>
				</div>
				</div>

				<div className="form-group">
        <div className="row">
        <div className="col-md-2">
					Niveau Admin
					<input type="number" className="form-control" id="adminLevel"
						value={this.state.adminLevel} onChange={this.handleAdminLevelChange}/>
				</div>
				</div>
				</div>

				<div className="form-group">
	      <div className="row">
	      <div className="col-md-12">
					Saisons
        	<table className="table table-striped table-hover table-sm">
        	<tbody>
         		<tr>
          		<th>ID</th>
            	<th>Name</th>
        		</tr>
        		{this.state.seasons.map(this.createSeasonRow)}
					</tbody>
        	</table>
				</div>
				</div>
				</div>

				<div className="form-group">
        <div className="row">
        <div className="col-md-12">
					<button type="submit" className="btn btn-primary">Sauvegarder</button>&nbsp;&nbsp;&nbsp;&nbsp;
					<button type="button" className="btn btn-primary"
						onClick={this.handleCancel}>Annuler</button>
				</div>
				</div>
				</div>

				</form>
			</div>
			</div>
		);
	}

	handlePlayerChange(dataValue) {
    this.setState({
    	playerId: dataValue
    });
	}

	handleAdminLevelChange(e) {
    this.setState({[e.target.id]: parseInt(e.target.value, 10)});
	}

	handleChange(e) {
    this.setState({[e.target.id]: e.target.value});
	}

	handleMemberActiveChange(e) {
		this.setState({memberActive: !this.state.memberActive})
	}

	handleCancel() {
		const path = '/admsafe/users';
		this.props.history.push(path);		
	}

  createLeagueRow(league, leagueIdx) {
    return (
      <tr key={league.id}>
        <td>{league.id}</td>
        <td>{league.name}</td>
      </tr>
    );
  }

  createSeasonRow(season, seasonIdx) {
    return (
      <tr key={season.id}>
        <td>{season.id}</td>
        <td>{season.name}</td>
      </tr>
    );
  }

}

export default EditUser;